import CalendarScheduleSlotModel from "../../models/CalendarScheduleSlotModel";

export default function FakeSlot({
  slot,
  onClick,
}: {
  slot: CalendarScheduleSlotModel;
  onClick: (slot: CalendarScheduleSlotModel) => void;
}) {
  return (
    <div
      role="button"
      onClick={() => onClick(slot)}
      className="w-full m-1 rounded-[4px] bg-transparent"
    />
  );
}
